// extracted by mini-css-extract-plugin
export default {"root":"LQz5TQ","closeButton":"hn0VS1","iframe":"U73P_q","bare":"V7x572"};